import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=732c7191"
import script from "./OrderForm.vue?vue&type=script&lang=ts"
export * from "./OrderForm.vue?vue&type=script&lang=ts"
import style0 from "./OrderForm.vue?vue&type=style&index=0&id=732c7191&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports